import { Box } from '@mui/material';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Loading } from 'components';
import ChangePassword from 'components/AdminMain/Content/ChangePassword/ChangePassword';
import DatabaseCleanup from 'components/AdminMain/Content/DatabaseCleanup/DatabaseCleanup';
import ReportGenerator from 'components/AdminMain/Content/ReportGenerator/ReportGenerator';
import ReportStatus from 'components/AdminMain/Content/ReportStatus/ReportStatus';
import UserRefresh from 'components/AdminMain/Content/UserRefresh/UserRefresh';
import YearSelector from 'components/AdminMain/Content/YearSelector/YearSelector';
import { getReportStatus, refreshMetadata } from 'store/actions';
import { selectLoading, selectToken, selectYear } from 'store/selectors';

const Content = () => {
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const token = useSelector(selectToken);
  const year = useSelector(selectYear);

  React.useEffect(() => {
    dispatch(refreshMetadata(token));
    if (year) {
      dispatch(getReportStatus(year, token));
    }
  }, [dispatch, token, year]);

  if (loading) {
    return <Loading />;
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      <ReportStatus />

      <YearSelector />

      <ChangePassword />

      <ReportGenerator />

      <UserRefresh />

      <DatabaseCleanup />
    </Box>
  );
};

export default Content;
